import { combineReducers } from "redux";
import ekyc from "./reducers/ekyc-reducer";

const appReducer = combineReducers({
  ekyc: ekyc,
});

export default appReducer;
